export default {

    "title": "Smtp",
    "entityName": "smtp",
    "id" : ["account_id", "sponsor_id"],
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "account.last_name",
        "descending": false
    },
    "fields": [
        
        {
            "value": "sponsor_id",
            "text": "Sponsor",
            "type": "list",
            "item-id": "id",
            "item-text": "name",
            "list" : [],
            "table": { "filter": true },
            "validators": [
                "required"
            ],
            "render": (item) => {
                return item.sponsor.name
            }
        },
        
        /*
        {
            small:true,
            "value": "account_id",
            "text": "account_id",
            "type": "number"
        },
        */

        
        {
            "value": "account_id",
            "text": "EMN Client",
            "title": "first_name",
            "id": "id",
            "type": "autocomplete",
            "table": { "filter": true },
            filter: (item, search) => [{ 'account.role': `EMN Client`,  'account.first_name' : '%' + search + "%"}],
            "validators": [
                "required"
            ]
            ,
            "render": (item) =>  {
                //debugger // eslint-disable-line no-debugger
                return `${item.account.first_name}`
            }
        },


        {
            small:true,
            "value": "host",
            "text": "Host",
            "type": "text",
            "validators": [
                "required"
            ]
        },

        {
            small:true,
            "value": "protocol",
            "text": "Protocol",
            "type": "list",
            list: ['ssl', 'tsl'],
            "validators": [
                "required"
            ]
        },
        {
            small:true,
            "value": "port",
            "text": "Port",
            "type": "number",
            "validators": [
                "required"
            ]
        },

        {
            small:true,
            "value": "username",
            "text": "Username",
            "type": "text",
            "validators": [
                "required",
                //ISSUE 266
                "email",
                "emaillen"
                //ISSUE 266
            ]
        },

        {
            small:true,
            "value": "password",
            "text": "Password",
            "type": "password",
            "validators": [
                "required"
            ]
        },
        {
            small:true,
            "value": "from",
            "text": "From",
            "type": "text",
            "validators": [
                "required",
                "email",
                "emaillen"
            ]
        },
        {
            "value": "fromName",
            "text": "From name",
            "type": "text",
            "table": { "filter": true },
            "validators": [
                "required"
            ]
        },




       
        
    ],
    "actions": [
        "upsert", "remove", "audit_trail"
        // { "value": "export", "text": "Export", "icon": "mdi-microsoft-excel", "color": "primary" }
    ]
}